"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detail = detail;
exports.downTemplate = downTemplate;
exports.importExe = importExe;
exports.queryList = queryList;
exports.reissue = reissue;
var _request = _interopRequireDefault(require("@/utils/request"));
function downTemplate(params) {
  return (0, _request.default)({
    url: '/portal/system/balance/downTemplate',
    method: 'get',
    params: params
  });
}
function queryList(params) {
  return (0, _request.default)({
    url: '/portal/system/balance/list',
    method: 'get',
    params: params
  });
}
function detail(params) {
  return (0, _request.default)({
    url: '/portal/system/balance/detail',
    method: 'get',
    params: params
  });
}
function reissue(data) {
  return (0, _request.default)({
    url: '/portal/system/balance/reissue',
    method: 'post',
    data: data
  });
}
function importExe(data) {
  return (0, _request.default)({
    url: '/portal/system/balance/import',
    method: 'post',
    data: data
  });
}